var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0722 3.78663C19.6646 3.54901 20.3354 3.54901 20.9278 3.78663L35.2415 9.52804C36.1061 9.87486 36.6667 10.6698 36.6667 11.5494V21.2744C36.6667 30.7321 29.3391 40.4925 20.7098 43.4633C20.2513 43.6211 19.7487 43.6211 19.2902 43.4633C10.661 40.4925 3.33333 30.7321 3.33333 21.2744V11.5494C3.33333 10.6698 3.89384 9.87486 4.75847 9.52804L19.0722 3.78663ZM20.9832 0.201201C20.3592 -0.0670669 19.6408 -0.0670669 19.0168 0.201201L1.36982 7.78797C0.534954 8.14688 0 8.92731 0 9.78633V21.2744C0 33.0043 8.24932 43.9862 19.4252 46.9258C19.8008 47.0247 20.1992 47.0247 20.5748 46.9259C31.7507 43.9862 40 33.0043 40 21.2744V9.78633C40 8.92731 39.4651 8.14688 38.6302 7.78797L20.9832 0.201201Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4274 27.7182C15.9694 28.1375 15.2338 28.1375 14.7758 27.7182L10.577 23.8736C10.119 23.4542 9.38339 23.4542 8.92538 23.8736L8.65126 24.1246C8.18371 24.5527 8.18371 25.2534 8.65126 25.6816L14.7758 31.2894C15.2338 31.7087 15.9694 31.7087 16.4274 31.2894L31.467 17.5188C31.9345 17.0906 31.9345 16.3899 31.467 15.9617L31.1929 15.7108C30.7349 15.2914 29.9992 15.2914 29.5412 15.7108L16.4274 27.7182Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.b592b9791086f636bcc2ee07e997df2c.svg";
export { ForwardRef as ReactComponent };